import { Box, useTheme } from "@mui/material";
import React, { memo } from "react";
import { isStaging } from "../theme";

const NotepayLogo = ({ sx }) => {
  const {
    palette: { mode },
  } = useTheme();
  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <Box
        width={35}
        height={35}
        borderRadius={100}
        sx={{
          background: 'url("https://cdn.notepay.com.br/logo-icon-1.png")',
          backgroundPosition: "center",
          backgroundSize: "100%",
          backgroundRepeat: "no-repeat",
          ...(isStaging && {
            filter: "hue-rotate(-40deg) saturate(1.4)",
          }),
          ...sx,
        }}
      />
      {isStaging && (
        <Box
          sx={{
            position: "absolute",
            bottom: -4,
            right: -10,
            bgcolor: "#E8711B",
            color: "#FFF",
            fontSize: "0.5rem",
            fontWeight: 800,
            lineHeight: 1,
            px: 0.5,
            py: "2px",
            borderRadius: "4px",
            letterSpacing: 0.5,
            boxShadow: "0 1px 3px rgba(0,0,0,.25)",
          }}
        >
          STG
        </Box>
      )}
    </Box>
  );
};

export default memo(NotepayLogo);
